import { FC, type JSX } from 'react';
import { useAppSelector } from '../../../../../../store/hooks/redux';
import { AvailablePlatformsEnum } from '../../../../constants/available-platforms';
import CreativeTypesEnum from '../../../../constants/creatives-types.enum';
import { IPlatformCreativeFormResolverProps } from '../models/form-resolver-props.interface';
import { ISingleCreativeFormValuesModel } from '../models/single-creative-form-values.model';
import BidtheatreSingleCreativeForm from './BidtheatreSingleCreativeForm';
import { useGetMeQuery } from '@/editor/services/http/users.api';
import BidtheatreVideoCreativeForm from './BidtheatreVideoCreativeForm';
import { IDynamicCreativeFormValuesModel } from '../models/dynamic-creative-form-values.model';
import BidtheatreDynamicCreativeForm from './BidtheatreDynamicCreativeForm';
import { getValueFromLs } from '@/shared/services/localstorage';
import { EDITOR_LS_CONSTANTS } from '@/editor/shared/constants/editor-LS.constants';


const BidtheatreFormsResolver: FC<IPlatformCreativeFormResolverProps> = ({
  creativeType,
  handleSubmit,
  updating,
}): JSX.Element => {
  const initialValuesFromStore = useAppSelector((state) => state.creativeStepSliceReducer.creativeFormsState);
  const { data: userData, isLoading: userDataLoading } = useGetMeQuery();

  const imageOrVideo = getValueFromLs(EDITOR_LS_CONSTANTS.IMAGE_FOR_VIDEO)
  const renderSwitch = (): JSX.Element => {
    switch (creativeType) {
      default:
        return <div></div>;
      case CreativeTypesEnum.SINGLE:
      case CreativeTypesEnum.CAROUSEL:
        return (
          <BidtheatreSingleCreativeForm
            updating={updating}
            initialValues={
              initialValuesFromStore[AvailablePlatformsEnum.BIDTHEATRE][
              CreativeTypesEnum.SINGLE
              ]! satisfies ISingleCreativeFormValuesModel
            }
            externalCompanyId={userData?.companyExternalId || ''}
          />
        );
      case CreativeTypesEnum.DYNAMIC:
        return (
          <BidtheatreDynamicCreativeForm
            updating={updating}
            initialValues={
              initialValuesFromStore[AvailablePlatformsEnum.BIDTHEATRE][
              CreativeTypesEnum.DYNAMIC
              ]! satisfies IDynamicCreativeFormValuesModel
            }
            externalCompanyId={userData?.companyExternalId || ''}
          />
        );
      case CreativeTypesEnum.VIDEO:
        if (imageOrVideo === 'image') {
          return (
            <BidtheatreSingleCreativeForm
              updating={updating}
              initialValues={
                initialValuesFromStore[AvailablePlatformsEnum.BIDTHEATRE][CreativeTypesEnum.SINGLE]! satisfies ISingleCreativeFormValuesModel
              }
              externalCompanyId={userData?.companyExternalId || ''}
            />
          );
        } else {
          return (
            <BidtheatreVideoCreativeForm
              updating={updating}
              initialValues={
                initialValuesFromStore[AvailablePlatformsEnum.BIDTHEATRE][CreativeTypesEnum.VIDEO]
              }
              externalCompanyId={userData?.companyExternalId || ''}
            />
          );
        }

    }
  };

  return <div>{renderSwitch()}</div>;
};
export default BidtheatreFormsResolver;
